import { CustomValidator } from "../../common/validation/types";
import { WorkAuthorValuesType } from "./WorkAuthorCommonStore";

/**
 * Un autor/compositor debe participar al menos en letra o en música.
 * No puede tener 0% en ambas simultáneamente (esa relación no aporta
 * titularidad y no tiene sentido de negocio). Cada porcentaje por
 * separado sí puede ser 0 (un compositor puro: 0% letra, N% música).
 */
export const workAuthorPercentagesValidator: CustomValidator<WorkAuthorValuesType> = {
  name: "workAuthorPercentagesValidator",
  validate(values, langStore) {
    const errors: Record<string, { message: string; fieldLabel: string }> = {};
    const cardErrors: Record<string, string[]> = {};

    const lyrics = Number(values.lyricsPercentage) || 0;
    const music = Number(values.musicPercentage) || 0;

    if (lyrics === 0 && music === 0) {
      errors.lyricsPercentage = {
        message: langStore.workAuthorPercentagesBothZero,
        fieldLabel: langStore.WorkAuthorLyricsPercentageLabel,
      };
      errors.musicPercentage = {
        message: langStore.workAuthorPercentagesBothZero,
        fieldLabel: langStore.WorkAuthorMusicPercentageLabel,
      };
    }

    return { errors, cardErrors };
  },
};
